import React from "react";
import { useNavigate } from "react-router";
import { filesystem_root, serverUrl } from "../../../config";

import GridItem from "../../../partials/gridItem";

import { navigationLabels, favoritesContentType } from "../../../utils/helpers";

import { BookOpen, FileText } from "react-feather";
import { InsertDriveFileOutlined, VideocamOutlined } from "@mui/icons-material";
import PieChart from "@mui/icons-material/PieChartOutlineOutlined";
import FormIcon from "@mui/icons-material/CreateOutlined";
import MicIcon from "@mui/icons-material/MicNoneRounded";
import TrainingIcon from "@mui/icons-material/SchoolOutlined";
import EventsIcon from "@mui/icons-material/CalendarTodayOutlined";
import ArticleIcon from "@mui/icons-material/ArticleOutlined";
import CollectionsOutlinedIcon from "@mui/icons-material/CollectionsOutlined";
import CompanyDirectoryIcon from "@mui/icons-material/PeopleOutlineOutlined";
import QuizIcon from "@mui/icons-material/QuizOutlined";

export default function LatestItem(props) {
  const navigate = useNavigate();
  const item = props.item;
  const isPublic = props.isPublic || false;

  const callbackRoute = (type) => {
    const route = {
      news: "news",
      blogs: "blogs",
      event: "events",
      presentation: "presentations/view",
      video: "videos",
      podcast: "podcasts",
      course: "training",
      quiz: "quizzes",
      document: "documents",
      poll: "polls",
      webform: "forms",
      company_directory: "company_directory",
      gallery: "galleries",
    };

    return route[type] || "";
  };

  let overlineStats =
    item.hasOwnProperty("comment_count") && item.hasOwnProperty("reactions");

  const getLogo = (type) => {
    switch (type) {
      case "news":
        return <FileText size={20} />;

      case "blogs":
        overlineStats = false;
        return <ArticleIcon sx={{ fontSize: 20 }} />;

      case "event":
        return <EventsIcon sx={{ fontSize: 20 }} />;

      case "presentation":
        overlineStats = false;
        return <BookOpen size={20} />;

      case "video":
        return <VideocamOutlined sx={{ fontSize: 20 }} />;

      case "podcast":
        return <MicIcon sx={{ fontSize: 20 }} />;

      case "course":
        overlineStats = false;
        return <TrainingIcon sx={{ fontSize: 20 }} />;

      case "quiz":
        overlineStats = false;
        return <QuizIcon sx={{ fontSize: 20 }} />;

      case "document":
        overlineStats = false;
        return <InsertDriveFileOutlined sx={{ fontSize: 20 }} />;

      case "poll":
        overlineStats = false;
        return <PieChart sx={{ fontSize: 20 }} />;

      case "webform":
        overlineStats = false;
        return <FormIcon sx={{ fontSize: 20 }} />;

      case "company_directory":
        overlineStats = false;
        return <CompanyDirectoryIcon sx={{ fontSize: 20 }} />;

      case "gallery":
        return <CollectionsOutlinedIcon sx={{ fontSize: 20 }} />;

      default:
        return;
    }
  };

  let imgSrc;

  if (item.field_featured_image && item.field_featured_image !== "") {
    imgSrc = `${serverUrl}${item.field_featured_image}`;
  } else if (item.thumbnail && item.thumbnail !== "") {
    imgSrc = `${filesystem_root}${item.thumbnail}`;
  } else if (item.field_image && item.field_image !== "") {
    imgSrc = `${serverUrl}${item.field_image}`;
  }

  if (item.bundle === "video") {
    if (item.remote_thumbnail) {
      imgSrc = `${item.remote_thumbnail}`;
    } else {
      imgSrc = `${serverUrl}/api/video/thumbnail?mid=${item.mid}`;
    }
  }

  const author = {
    name: item.author_information.full_name,
    image: `${item.author_information.user_picture}`,
  };

  return (
    <GridItem
      xs={12}
      sm={12}
      md={12}
      xl={6}
      itemClass="latest"
      bundle={props.item?.bundle}
      nid={item.nid}
      isPublic={isPublic}
      title={item.title || item.question}
      titleVariant={"h4"}
      titleLH={"medium"}
      field_body={item.summary || item.body}
      overlineCategory={true}
      overlineCategoryLogo={getLogo(item.bundle)}
      overlineStats={overlineStats}
      overlineCategoryVariant={"subtitle1"}
      overlineCategoryWeight={"regular"}
      commentCount={item.comment_count}
      reactionCount={item.reactions}
      category_label={navigationLabels(item.bundle)}
      author={author}
      hasImg={true}
      imgSrc={imgSrc}
      disableChip={true}
      footerDate={true}
      created={item.created}
      cardActionCallBack={() => {
        const path = `/${callbackRoute(item.bundle)}/${item?.id}`;
        if (item.bundle === "presentation") {
          window.open(path, "_blank");
        } else {
          let link = `${path}?referrer=/`;

          if (isPublic) {
            link += `&hash=${item.field_access_token}`;
          }

          navigate(link);
        }
      }}
      cardAction={true}
      contentType={favoritesContentType(item.bundle)}
    />
  );
}
